import axios from "axios";
// config
import { HOST_API_KEY } from "../config";

// ----------------------------------------------------------------------

export const axiosInstance = axios.create({
  baseURL: HOST_API_KEY,
  withCredentials: true,
  xsrfCookieName: "csrf_token",
  xsrfHeaderName: "X-CSRF-Token",
});

axiosInstance.interceptors.request.use(
  async (config) => {
    config.headers["Accept"] = "application/json";

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;

    if (
      (error.response?.status === 401 || error.response?.status === 403) &&
      !originalRequest._retry &&
      !originalRequest.url?.includes("refresh")
    ) {
      originalRequest._retry = true;

      try {
        await axios.post(
          HOST_API_KEY + "/auth/refresh-access-cookies",
          {},
          {
            withCredentials: true,
            xsrfCookieName: "csrf_token",
            xsrfHeaderName: "X-CSRF-Token",
          }
        );

        return axiosInstance(originalRequest);
      } catch (refreshError) {
        window.dispatchEvent(new Event("onTokenExpired"));
        // window.location.href = paths.auth.jwt.login;

        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
